import React, { useRef } from 'react';
import { FileText, Download, ExternalLink } from 'lucide-react';
import './ViewerComponents.css';

interface DocumentViewerProps {
  contentUrl: string;
  title: string;
}

export const DocumentViewer: React.FC<DocumentViewerProps> = ({ contentUrl, title }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // Check if it's a PDF
  const isPdf = contentUrl.toLowerCase().endsWith('.pdf');

  return (
    <div className="content-viewer content-viewer--document">
      <div className="content-viewer__header">
        <div className="content-viewer__header-left">
          <FileText size={20} className="content-viewer__icon" />
          <span className="content-viewer__title">Document Viewer</span>
        </div>
        <div className="content-viewer__header-right">
          <a
            href={contentUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="content-viewer__btn content-viewer__btn--secondary"
            title="Open in new tab"
          >
            <ExternalLink size={18} />
            Open
          </a>
          <a
            href={contentUrl}
            download
            className="content-viewer__btn content-viewer__btn--primary"
            title="Download document"
          >
            <Download size={18} />
            Download
          </a>
        </div>
      </div>
      <div className="content-viewer__body">
        {isPdf ? (
          <iframe
            ref={iframeRef}
            src={`${contentUrl}#toolbar=1&navpanes=1&scrollbar=1`}
            className="content-viewer__iframe"
            title={title}
          />
        ) : (
          <iframe
            ref={iframeRef}
            src={`https://docs.google.com/viewer?url=${encodeURIComponent(contentUrl)}&embedded=true`}
            className="content-viewer__iframe"
            title={title}
          />
        )}
      </div>
    </div>
  );
};
